// extracted by mini-css-extract-plugin
module.exports = {"agendamentos":"Jornada_agendamentos__2CWAZ"};